<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="attr03"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.attr03"
          selectType="select"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'ATTR03' }"
          searchParam="lookupValue"
        />
        <global-select
          v-decorator="['factoryCode', { rules: [{ required: true }] }]"
          slot="factoryCode"
          :value.sync="queryParams.factoryCode"
          :dropdown-match-select-width="false"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :allow-clear="false"
          :default-active-first-option="true"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvOnhandQuantitiesNewExport" ref="download" />
        <a-button type="primary" @click="handleExport" v-hasPermi="['inv:invOnhandQuantities:wmsStockQtyExport']">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.STOCK_ATOM_REPORT_LIST, // 表格方案配置唯一值
              }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiInvGetWmsStockQtyList, apiInvOnhandQuantitiesNewExport } from '@/api/report/stock-atom-report'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Stock-atom-report', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      apiInvOnhandQuantitiesNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiInvGetWmsStockQtyList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        factoryCode: undefined,
        tenantId: undefined,
        skuKey: undefined,
        skuName: undefined,
        attr03: '0',
        attr09: undefined,
        lotKey: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '组织',
          decorator: ['factoryCode'],
          type: 'factoryCode'
        },
        {
          label: '子库编码',
          decorator: ['tenantId'],
          type: 'input'
        },
        {
          label: '物料编码',
          decorator: ['skuKey'],
          type: 'input'
        },
        {
          label: '物料名称',
          decorator: ['skuName'],
          type: 'input'
        },
        {
          label: '采购类型',
          decorator: ['attr03'],
          type: 'attr03'
        },
        {
          label: '库存层级',
          decorator: ['attr09'],
          type: 'input'
        },
        {
          label: '生产批次',
          decorator: ['lotKey'],
          type: 'input'
        }
      ],
      // 表格字段
      columns: [
        {
          title: '子库编码',
          dataIndex: 'tenantId',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '子库',
          dataIndex: 'invLocationName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '库位',
          dataIndex: 'locKey',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'skuKey',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'skuName',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specModel',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'unit',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '批次',
          dataIndex: 'lotKey',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '现有量',
          dataIndex: 'onhandQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '可用量',
          dataIndex: 'availableQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '分配量',
          dataIndex: 'assignedQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '拣货量',
          dataIndex: 'pickQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '组织代码',
          dataIndex: 'attr01',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '子库代码',
          dataIndex: 'attr02',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '采购类型',
          dataIndex: 'attr03',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '入库日期',
          dataIndex: 'deliveryDate',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '供应商代码',
          dataIndex: 'attr06',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '工单号',
          dataIndex: 'attr07',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划单号',
          dataIndex: 'attr08',
          align: 'center',
          width: 180,
          ellipsis: true
        },
        {
          title: '色差标志/库存层级',
          dataIndex: 'attr09',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '生产批次号',
          dataIndex: 'attr10',
          align: 'center',
          width: 180,
          ellipsis: true
        },
        {
          title: '分包序号',
          dataIndex: 'attr14',
          align: 'center',
          width: 180,
          ellipsis: true
        },
        {
          title: '成品流水码',
          dataIndex: 'snkey',
          align: 'center',
          width: 180,
          ellipsis: true
        },
        {
          title: '源子库',
          dataIndex: 'attr16',
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      const params = {
       ...this.queryParams,
       ...value
      }
      delete params.searchFormLabel
      if (params.attr03.toString() === '0') {
        delete params.attr03
      }
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationCode: undefined,
        tenantId: undefined,
        skuKey: undefined,
        skuName: undefined,
        attr03: '0',
        attr09: undefined,
        lotKey: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
      // this.download('inv/invOnhandQuantities/wmsStockQtyExport', this.$refs.dataTable.searchParams, `库存余额_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less"></style>
